import { Component, OnInit } from '@angular/core';
import { DataService } from '../services/dataService.service';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss'],
})
export class ContactComponent implements OnInit {

    static componentName = 'ContactComponent';
    post: any;

    constructor(
        private dataService: DataService,
    ) {}

    getPost(): void {
        this.dataService.getPost('kontakt')
            .subscribe(res => this.post = res);
    }

    ngOnInit() {
        this.getPost();

        setTimeout(() => {
            if (document.querySelectorAll('.contact-hero').length) {
                document.querySelectorAll('.contact-hero')[0].classList.add('show');
            }
        }, 1300);
    }

}



// WEBPACK FOOTER //
// E:/MBP/BloomyNG/src/app/contact/contact.component.ts